import { TrustAsHtmlFilterModule } from '@b2b/common/filters';
import { input } from '@b2b/types/core';
import angular, { IOnChangesObject } from 'angular';

type NoticeType = 'default' | 'info' | 'warning' | 'error';
interface Notice {
  type: NoticeType;
  message: string;
}

class NoticesController {
  static $inject = ['$element'];

  type = input.required<NoticeType>('default');
  notices = input.required<Notice[]>([]);

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-notices');

    if (!this.type) {
      throw new Error('acmeNotices.type is required');
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.notices) {
      if (this.notices == null) {
        this.notices = [];
      }

      if (this.notices.length) {
        this.$element.addClass('show');
      } else {
        this.$element.removeClass('show');
      }
    }
  }
}

export const NoticesComponentModule = angular
  .module('acme.common.component.notices', [TrustAsHtmlFilterModule])
  .component('acmeNotices', {
    templateUrl: 'common/components/notices/notices.component.tpl.html',
    controller: NoticesController,
    bindings: {
      type: '<',
      notices: '<',
    },
  }).name;
